module.exports = "/images/logo-icon.png?ee0007111df4c257036449fc0c6660be";